import { useStaticQuery, graphql } from "gatsby"
import { Product } from "@shopify/hydrogen-react/storefront-api-types"

export const useBackInStock = (product: Product) => {
  const { data } = useStaticQuery<GatsbyTypes.StaticBackInStockQuery>(graphql`
    query StaticBackInStock {
      data: sanitySettingBackInStock {
        title1
        title2
        content1
        subContent1
        content2
        button1
        emailPlaceholder
        errorMessage
        comingSoonTitle1
        comingSoonContent1
        comingSoonSubContent1
        comingSoonButton1
        comingSoonTitle2
        comingSoonContent2
      }
    }
  `)

  const title1 = data?.title1 || ""
  const content1 = data?.content1 ? data.content1.split("\n").filter(item => item) : []
  const subContent1 = data?.subContent1 ? data.subContent1.split("\n").filter(item => item) : []
  const button1 = data?.button1 || ""
  const title2 = data?.title2 || ""
  const productTitle = product?.title
  const content2 = data?.content2 ? data.content2.split("\n").map(item => item.replace("{item}", productTitle)) : []
  const emailPlaceholder = data?.emailPlaceholder || ""
  const errorMessage = data?.errorMessage || ""
  const comingSoonTitle1 = data?.comingSoonTitle1 || ""
  const comingSoonContent1 = data?.comingSoonContent1 ? data.comingSoonContent1.split("\n").filter(item => item) : []
  const comingSoonSubContent1 = data?.comingSoonSubContent1 ? data.comingSoonSubContent1.split("\n").filter(item => item) : []
  const comingSoonButton1 = data?.comingSoonButton1 || ""
  const comingSoonTitle2 = data?.comingSoonTitle2 || ""
  const comingSoonContent2 = data?.comingSoonContent2
    ? data.comingSoonContent2.split("\n").map(item => item.replace("{item}", productTitle))
    : []

  return {
    title1,
    content1,
    button1,
    subContent1,
    title2,
    content2,
    productTitle,
    emailPlaceholder,
    errorMessage,
    comingSoonTitle1,
    comingSoonContent1,
    comingSoonSubContent1,
    comingSoonButton1,
    comingSoonTitle2,
    comingSoonContent2,
  }
}
